import { TFunction } from 'i18next';
import { TireBrandDistributionData } from '../../../../store/analytics/types/tire-brand-distribution.types';

export const brandField = 'brand';
export const newField = 'newCount';
export const reusableField = 'reusableCount';

export function buildChartData(data: TireBrandDistributionData[], translate: TFunction): any[] {
    const result: any[] = [];
    data.forEach((row) => {
        const r = {};
        r[brandField] = row.brand;
        r[newField] = row.newCount;
        r[reusableField] = row.reusableCount;
        result.push(r);
    });
    console.log("Chart Data: ", result);
    return result.reverse();
}
